import React from 'react';
import _ from 'lodash';
import { PropTypes } from 'react';

const DropdownMenu = ({ name, label, options, activeOptions, onClickOption }) => {
	if(options.length === 0){
		return null
	}

	const opt = options.map(o => {
		let className = 'option';
		if(activeOptions.includes(o)){
			className += ' active';
		}

		let thumbnail = _.result(o, 'acf.image', null);
		if(thumbnail){
			thumbnail = (<img src={ thumbnail } />);
		}

		return (
			<div key={o.slug} className={className} onClick={() => onClickOption(name, o)}>
				{ thumbnail }
				<span dangerouslySetInnerHTML={{__html: o.name}} />
			</div>
		)
	});

	let classList = ['dropdown-menu', name];

	return (
		<div className={ classList.join(' ') }>
			<label className="dropdown-label"><span dangerouslySetInnerHTML={{__html: label}} /> <i className="icon icon-arrow-down" data-grunticon-embed /></label>
			<div className="options">
				{ opt }
			</div>
		</div>
	);
}

DropdownMenu.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	options: PropTypes.array,
	activeOptions: PropTypes.array,
	onClickOption: PropTypes.func.isRequired
};

export default DropdownMenu;
